import { render, staticRenderFns } from "./SearchCompanies.vue?vue&type=template&id=0b4acefe"
import script from "./SearchCompanies.vue?vue&type=script&lang=js"
export * from "./SearchCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports